import React, { useEffect } from 'react';
import { ComponentProps, getAutoFdKey } from '../Common';
import { EFieldType } from '../../models/EFieldType';
import { FkField, TFkFieldProps } from '../FkField/FkField';
import { TextFieldEx, TextFieldExProps } from '../FkText/TextFieldEx';

// Fk - Formik. Warning!!! Don't extend from TextField props - all UI parts must be inside component
// Don't add value field!!! work only over formik.
type Props = TextFieldExProps & ComponentProps;

export const FkEmail = (props: Props) => {
  const { fieldType, fieldName, ...rest } = props;
  useEffect(
    () => assert(fieldType === EFieldType.Email, 'Use wrong control or wrong config (email)'),
    []
  );

  return (
    <FkField componentProps={props}>
      {({ field, fieldEx, form }: TFkFieldProps) => {
        const { isSubmitting } = form;
        const { fieldError, showError, isTouched } = fieldEx;

        return (
          <TextFieldEx
            {...field}
            {...rest}
            placeholder={''}
            fdKey={props.fdKey || getAutoFdKey(fieldType, fieldName)}
            disabled={isSubmitting || props.disabled}
            showError={showError}
            isTouched={isTouched}
            fieldError={fieldError}
            onChange={(e) => {
              form.setFieldValue(props.name, e.target.value);
              props.onChange && props.onChange(e);
            }}
            onBlur={(e) => {
              field.onBlur(e);
              props.onBlur && props.onBlur(e);
            }}
          />
        );
      }}
    </FkField>
  );
};
